import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function Vendorreport() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },

    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "Product Price",
      accessorKey: "Product Price",
    },
    {
      header: "Name",
      accessorKey: "Name",
    },
    {
      header: "Name Arabic",
      accessorKey: "Name Arabic",
    },
    {
      header: "sub total",
      accessorKey: "sub total",
    },
    {
      header: "Discount",
      accessorKey: "Discount",
    },
    {
      header: "Vat",
      accessorKey: "Vat",
    },{
        header: "Vendor name",
        accessorKey: "Vendor name",
      },
    
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: "Submit",
    },
  ]);

  const [selectButton] = useState([
    {
      placeholder: "User",
    }, {
        placeholder: "Vendor Name",
      },
  ]);
  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Vendor report"}
        buttonDataa={buttonDataa}
        selectButton={selectButton}
      />
    </main>
  );
}

export default Vendorreport;
